/* MyKidss cart drawer UX v3 — keep cart layout, refine only Frequently Bought Together. */
(function () {
  var productCache = new Map();
  var enhanceTimer = null;
  var sliderTimer = null;

  var bagSvg = '<svg class="mykidss-upsell-bag-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M21,4.5H17.64V2.63A2.62,2.62,0,0,0,15,0H9A2.62,2.62,0,0,0,6.38,2.63V4.5H3a3,3,0,0,0-3,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V7.5a3,3,0,0,0-3-3ZM8.64,2.63A.37.37,0,0,1,9,2.25h6a.37.37,0,0,1,.37.38V4.5H8.66V2.63ZM21.76,21a.75.75,0,0,1-.75.75H3A.75.75,0,0,1,2.27,21V7.52A.75.75,0,0,1,3,6.77H6.39V9H8.64V6.77h6.75V9h2.25V6.77H21a.75.75,0,0,1,.75.75Z" fill="currentColor"></path></svg>';

  function refreshDrawerHeight() {
    var cart = document.querySelector('cart-drawer.minicart-panel');
    if (!cart) return;
    var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    cart.style.setProperty('--mykidss-drawer-vh', viewportHeight + 'px');
  }

  function localeRoot() {
    return (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  }

  function labels() {
    var locale = localeRoot();
    var isPolish = locale === 'pl';
    var isDanish = locale === 'da';
    return {
      add: (window.variantStrings && window.variantStrings.addToCart) || (isPolish ? 'Dodaj do koszyka' : isDanish ? 'Læg i kurv' : 'Add to cart'),
      choose: isPolish ? 'Wybierz opcje' : isDanish ? 'Vælg muligheder' : 'Choose options',
      soldOut: (window.variantStrings && window.variantStrings.soldOut) || (isPolish ? 'Wyprzedane' : isDanish ? 'Udsolgt' : 'Sold out')
    };
  }

  function installFbtStyles() {
    if (document.getElementById('mykidss-fbt-v3-style')) return;

    var style = document.createElement('style');
    style.id = 'mykidss-fbt-v3-style';
    style.textContent = `
      /* FBT only — larger editorial cards like the earlier MyKidss layout */
      cart-drawer.minicart-panel .comparatively-products-card {
        margin: 0 !important;
        padding: 19px 20px 22px !important;
        background: #e9e7dd !important;
        border-top: 0 !important;
        border-bottom: 1px solid #dedbd1 !important;
      }

      cart-drawer.minicart-panel .comparatively-head {
        position: relative !important;
        min-height: 24px !important;
        margin: 0 0 15px !important;
        padding: 0 76px 0 0 !important;
        background: transparent !important;
        border: 0 !important;
      }

      cart-drawer.minicart-panel .comparatively-head span {
        display: block !important;
        padding: 0 !important;
        background: transparent !important;
        color: #292925 !important;
        font-size: 13px !important;
        line-height: 1.3 !important;
        font-weight: 750 !important;
        letter-spacing: .065em !important;
        text-transform: uppercase !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product {
        margin: 0 -7px !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-card {
        display: block !important;
        width: 46% !important;
        min-width: 46% !important;
        padding: 0 7px !important;
        vertical-align: top !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-media {
        position: relative !important;
        display: block !important;
        width: 100% !important;
        margin: 0 0 10px !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-image {
        display: block !important;
        width: 100% !important;
        aspect-ratio: 1 / 1 !important;
        overflow: hidden !important;
        border-radius: 2px !important;
        background: #fff !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-image img,
      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-image picture,
      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-image .media-image {
        width: 100% !important;
        height: 100% !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-image img {
        object-fit: contain !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-info {
        display: block !important;
        padding: 0 2px !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-info > a {
        display: block !important;
        color: inherit !important;
        text-decoration: none !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-info p {
        display: -webkit-box !important;
        min-height: 35px !important;
        margin: 0 0 8px !important;
        overflow: hidden !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
        color: #282824 !important;
        font-size: 13px !important;
        line-height: 1.35 !important;
        font-weight: 500 !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .price-wrapper {
        display: block !important;
        min-height: 22px !important;
        margin: 0 0 7px !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .item-price,
      cart-drawer.minicart-panel #cart-upsell-product .price-wrapper .item-price {
        color: #171715 !important;
        font-size: 14px !important;
        line-height: 1.3 !important;
        font-weight: 750 !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .item-price-old {
        font-size: 11px !important;
      }

      /* Keep the original View details action as a secondary button */
      cart-drawer.minicart-panel #cart-upsell-product quick-view {
        display: block !important;
        width: auto !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product quick-view > .btn {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: auto !important;
        min-width: 0 !important;
        min-height: 34px !important;
        margin: 0 !important;
        padding: 8px 12px !important;
        border: 1px solid #171715 !important;
        border-radius: 0 !important;
        background: #171715 !important;
        color: #fff !important;
        font-size: 11px !important;
        line-height: 1.15 !important;
        font-weight: 650 !important;
        letter-spacing: .01em !important;
        text-transform: none !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product quick-view > .btn:hover {
        background: #fff !important;
        color: #171715 !important;
      }

      /* Small cart icon over the image, matching the product-card quick-add language */
      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-quick-add,
      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-options-link {
        position: absolute !important;
        right: 10px !important;
        bottom: 10px !important;
        z-index: 5 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 35px !important;
        height: 35px !important;
        min-width: 35px !important;
        min-height: 35px !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 1px solid rgba(255,255,255,.92) !important;
        border-radius: 50% !important;
        background: #11110f !important;
        color: #fff !important;
        box-shadow: 0 3px 12px rgba(0,0,0,.16) !important;
        text-decoration: none !important;
        cursor: pointer !important;
        transition: transform .16s ease, background-color .16s ease, color .16s ease !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-quick-add:hover,
      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-options-link:hover {
        transform: translateY(-1px) !important;
        background: #fff !important;
        color: #11110f !important;
        border-color: #11110f !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-quick-add[disabled],
      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-quick-add[aria-disabled="true"] {
        opacity: .42 !important;
        cursor: default !important;
        transform: none !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-quick-add.mykidss-loading {
        opacity: .58 !important;
        pointer-events: none !important;
      }

      cart-drawer.minicart-panel #cart-upsell-product .mykidss-upsell-bag-icon {
        width: 15px !important;
        height: 15px !important;
        display: block !important;
      }

      /* Keep carousel navigation restrained beside the heading */
      cart-drawer.minicart-panel #cart-upsell-product .flickity-prev-next-button {
        top: -40px !important;
      }

      @media screen and (max-width: 767px) {
        cart-drawer.minicart-panel .comparatively-products-card {
          padding: 18px 18px 21px !important;
        }

        cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-card {
          width: 54% !important;
          min-width: 54% !important;
        }
      }

      @media screen and (max-width: 480px) {
        cart-drawer.minicart-panel .comparatively-products-card {
          padding-left: 16px !important;
          padding-right: 16px !important;
        }

        cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-card {
          width: 64% !important;
          min-width: 64% !important;
        }

        cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-info p {
          min-height: 34px !important;
          font-size: 12.5px !important;
        }
      }

      @media screen and (max-width: 380px) {
        cart-drawer.minicart-panel #cart-upsell-product .comparatively-product-card {
          width: 70% !important;
          min-width: 70% !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function productJsonUrl(productUrl) {
    var url = new URL(productUrl, window.location.origin);
    var pathname = url.pathname.replace(/\/$/, '');
    return pathname.endsWith('.js') ? pathname : pathname + '.js';
  }

  function getProductData(productUrl) {
    var endpoint = productJsonUrl(productUrl);
    if (productCache.has(endpoint)) return productCache.get(endpoint);

    var request = fetch(endpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product JSON request failed: ' + response.status);
      return response.json();
    });

    productCache.set(endpoint, request);
    request.catch(function () { productCache.delete(endpoint); });
    return request;
  }

  function publishCartEvent(eventName, payload) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[eventName]) {
        publish(PUB_SUB_EVENTS[eventName], payload);
      }
    } catch (error) {
      console.warn('[MyKidss cart UX] Cart event publish skipped.', error);
    }
  }

  function refreshFlickity() {
    window.clearTimeout(sliderTimer);
    sliderTimer = window.setTimeout(function () {
      try {
        var slider = document.querySelector('#cart-upsell-product');
        if (!slider || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flickity) return;
        var $slider = window.jQuery(slider);
        if (!$slider.hasClass('flickity-enabled')) return;
        $slider.flickity('reloadCells');
        $slider.flickity('resize');
      } catch (error) {
        console.warn('[MyKidss cart UX] FBT slider refresh skipped.', error);
      }
    }, 120);
  }

  function ensureMediaWrapper(card) {
    var image = card.querySelector('.comparatively-product-image');
    if (!image) return null;
    if (image.parentElement && image.parentElement.classList.contains('mykidss-upsell-media')) {
      return image.parentElement;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'mykidss-upsell-media';
    image.parentNode.insertBefore(wrapper, image);
    wrapper.appendChild(image);
    return wrapper;
  }

  function createQuickAddButton(variant, copy) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mykidss-upsell-quick-add';
    button.innerHTML = bagSvg;

    if (!variant.available) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-label', copy.soldOut);
      button.title = copy.soldOut;
      return button;
    }

    button.setAttribute('data-mykidss-upsell-add', String(variant.id));
    button.setAttribute('aria-label', copy.add);
    button.title = copy.add;
    return button;
  }

  function createOptionsLink(productUrl, copy) {
    var link = document.createElement('a');
    link.className = 'mykidss-upsell-options-link';
    link.href = productUrl;
    link.innerHTML = bagSvg;
    link.setAttribute('aria-label', copy.choose);
    link.title = copy.choose;
    return link;
  }

  function enhanceUpsells(root) {
    var scope = root || document;
    var copy = labels();

    scope.querySelectorAll('#cart-upsell-product .comparatively-product-card').forEach(function (card) {
      if (card.dataset.mykidssFbtReady === 'true' || card.dataset.mykidssFbtReady === 'pending') return;

      var details = card.querySelector('quick-view[data-product-url]');
      var productUrl = details ? details.dataset.productUrl : '';
      var media = ensureMediaWrapper(card);
      if (!media || !productUrl) return;

      card.dataset.mykidssFbtReady = 'pending';

      getProductData(productUrl)
        .then(function (product) {
          if (!card.isConnected || !media.isConnected) return;
          var variants = Array.isArray(product.variants) ? product.variants : [];
          if (!variants.length) {
            delete card.dataset.mykidssFbtReady;
            return;
          }

          media.querySelectorAll('.mykidss-upsell-quick-add, .mykidss-upsell-options-link').forEach(function (el) {
            el.remove();
          });

          if (variants.length === 1) {
            media.appendChild(createQuickAddButton(variants[0], copy));
          } else {
            media.appendChild(createOptionsLink(productUrl, copy));
          }

          card.dataset.mykidssFbtReady = 'true';
        })
        .catch(function (error) {
          delete card.dataset.mykidssFbtReady;
          console.warn('[MyKidss cart UX] Could not enhance FBT product.', error);
        });
    });

    refreshFlickity();
  }

  function scheduleEnhance(root) {
    window.clearTimeout(enhanceTimer);
    enhanceTimer = window.setTimeout(function () {
      installFbtStyles();
      enhanceUpsells(root || document);
    }, 80);
  }

  function attachDrawerObserver(cart) {
    if (!cart || cart._mykidssUxObserver) return;

    var observer = new MutationObserver(function (mutations) {
      var needsRefresh = mutations.some(function (mutation) {
        return mutation.type === 'childList' && mutation.addedNodes.length;
      });
      if (needsRefresh) scheduleEnhance(cart);
    });

    observer.observe(cart, { childList: true, subtree: true });
    cart._mykidssUxObserver = observer;
  }

  function markDrawerReady() {
    var cart = document.querySelector('cart-drawer.minicart-panel');
    if (!cart) return;
    cart.classList.add('mykidss-cart-v2-ready');
    refreshDrawerHeight();
    installFbtStyles();
    attachDrawerObserver(cart);
    scheduleEnhance(cart);
  }

  function addUpsellVariant(button) {
    if (!button || button.classList.contains('mykidss-loading') || button.getAttribute('aria-disabled') === 'true') return;

    var variantId = button.getAttribute('data-mykidss-upsell-add');
    var cart = document.querySelector('cart-drawer.minicart-panel');
    if (!variantId || !cart) return;

    button.classList.add('mykidss-loading');
    button.setAttribute('aria-disabled', 'true');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (section) { return section.id; }));
      formData.append('sections_url', window.location.pathname);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          publishCartEvent('cartError', {
            source: 'mykidss-cart-upsell',
            productVariantId: variantId,
            errors: response.description,
            message: response.message
          });
          return;
        }

        publishCartEvent('cartUpdate', {
          source: 'mykidss-cart-upsell',
          productVariantId: variantId
        });

        if (!response.sections || typeof cart.renderContents !== 'function') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        cart.renderContents(response);
        cart.classList.add('active');
        document.body.classList.add('no-scroll');
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

        window.setTimeout(function () {
          refreshDrawerHeight();
          scheduleEnhance(cart);
        }, 100);
      })
      .catch(function (error) {
        console.error('[MyKidss cart UX] FBT quick add failed.', error);
      })
      .finally(function () {
        if (button.isConnected) {
          button.classList.remove('mykidss-loading');
          button.removeAttribute('aria-disabled');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-mykidss-upsell-add]');
    if (!addButton) return;
    event.preventDefault();
    event.stopPropagation();
    addUpsellVariant(addButton);
  });

  document.addEventListener('DOMContentLoaded', markDrawerReady);
  document.addEventListener('shopify:section:load', markDrawerReady);

  window.addEventListener('resize', function () {
    refreshDrawerHeight();
    refreshFlickity();
  });

  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () {
      refreshDrawerHeight();
      refreshFlickity();
    }, 120);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', refreshDrawerHeight);
  }
})();
